import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-male",
  "use": "icon-si-glyph-male-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-male\" id=\"icon-si-glyph-male\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>982</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M16.875,5.884 L16.875,0.125 L11.113,0.125 L13.336,2.346 L9.633,6.057 C8.748,5.429 7.668,5.055 6.502,5.055 C3.498,5.055 1.055,7.507 1.055,10.522 C1.055,13.538 3.498,15.99 6.502,15.99 C9.504,15.99 11.946,13.538 11.946,10.522 C11.946,9.344 11.568,8.254 10.935,7.361 L14.637,3.649 L16.875,5.884 L16.875,5.884 Z M6.464,14.165 C4.518,14.165 2.932,12.584 2.932,10.635 C2.932,8.689 4.518,7.106 6.464,7.106 C8.41,7.106 9.996,8.689 9.996,10.635 C9.996,12.584 8.41,14.165 6.464,14.165 L6.464,14.165 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-male.svg
// module id = ZGus
// module chunks = 62